import { useEffect } from 'react';

import { Container, Flex } from '@grupoboticario/flora-react';
import { ExclamationMarkHexagonIcon } from '@grupoboticario/flora-react-icons';
import slugify from 'slugify';

import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';
import { useTracking } from 'hooks';
import { ErrorRegistration } from 'store';

import Styles from './MessageUpdateError.styles';
import StylesDrawer from '../../../../Drawers.styles';
import { PrimaryActions, SecondaryActions } from '../../Actions';
import { MessageTryAgain } from '../MessageTryAgain';

type MessageUpdateErrorProps = {
  error: ErrorRegistration;
  type: string;
};

export const MessageUpdateError = ({ error, type }: MessageUpdateErrorProps) => {
  const { sendDataToGTM } = useTracking();

  const primaryAction = error?.userMessage?.primaryAction;
  const secondaryAction = error?.userMessage?.secondaryAction;

  useEffect(() => {
    const slugMessage = slugify(
      error?.errorId || error?.updateRegistrationError || error?.errorMessage || '',
      {
        lower: true,
        replacement: '-',
      }
    );
    const pageTitle = `Perfil - Editar ${type} - Erro ${slugMessage}`;

    sendDataToGTM({
      event: 'page_view',
      event_parameters: {
        page_title: pageTitle,
        page_location: `${window.location.href}:${slugMessage}`,
      },
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error?.isGenericError) {
    return <MessageTryAgain type={type} />;
  }

  const ComponentPrimaryAction = primaryAction ? PrimaryActions[primaryAction] : null;
  const ComponentSecondaryAction = secondaryAction ? SecondaryActions[secondaryAction] : null;

  return (
    <StylesDrawer.DrawerSection direction='column' gap='$2'>
      <Container size='medium' data-autotagging-flora-section={`alterar_${type}`}>
        <Styles.Content gap='$2' direction='column' align='center'>
          <ExclamationMarkHexagonIcon color='$backgroundAltSecondary' size={47} />
          <ResponsiveFloraTypography
            color='$backgroundAltPrimary'
            fontSize='title'
            fontWeight='bold'
          >
            {error?.userMessage?.errorTitle}
          </ResponsiveFloraTypography>
        </Styles.Content>
        <Styles.Content gap='$2' direction='column'>
          <ResponsiveFloraTypography color='$backgroundAltSecondary' fontSize='bodyLargeShort'>
            {error?.userMessage?.errorMessage}
          </ResponsiveFloraTypography>
        </Styles.Content>
        <Flex
          direction='column'
          css={{
            marginBottom: '$3',
          }}
        >
          {ComponentPrimaryAction && <ComponentPrimaryAction type={type} hierarchy='primary' />}
        </Flex>
        <Flex direction='column'>
          {ComponentSecondaryAction && (
            <ComponentSecondaryAction type={type} hierarchy='secondary' />
          )}
        </Flex>
      </Container>
    </StylesDrawer.DrawerSection>
  );
};

export default MessageUpdateError;
